/**
 * This is based on control_imagefile.js
 * 1. Only supports a single image (not multiple files)
 * 2. Provides a crop control using cropper.js
 * 3. Does not automatically map form fields. Explicit configuration is required
 *    While it is initialized on the input with data-fd-control="imagecropper"
 *    it looks up to a parent data-image-cropper container, then locates the other inputs
  <div data-image-cropper>
    <input asp-for="Form.FeatureImage.OriginalImageFile" data-fd-control="imagecropper" accept="image/*" />
    <input data-image-cropper-input="cropped-file" asp-for="Form.FeatureImage.CroppedImageFile" accept="image/*" />
    <input data-image-cropper-input="original-url" type="hidden" asp-for="Form.FeatureImage.OriginalUrl" />
    <input data-image-cropper-input="cropped-url" type="hidden" asp-for="Form.FeatureImage.CroppedUrl" />
    <input data-image-cropper-input="fallback-url" type="hidden" asp-for="Form.FeatureImageUrl" />
    <input data-image-cropper-input="meta" type="hidden" asp-for="Form.FeatureImage.Meta" />
    <input data-image-cropper-input="removed" type="hidden" asp-for="Form.FeatureImage.ImageRemoved" />
  </div>
 */
(function ($) {
  'use strict';

  function safeJsonParse(input) {
    try {
      return JSON.parse(input);
    } catch (e) {
      // fail silently. caller will get undefined
    }
  }

  $.widget("fd.control_imagecropper", {
    options: {
      callback: function () { },
      choosefiletext: 'Choose File',
      choosefileclass: 'btn btn-info',
      choosefileicon: "<i class='fas fa-plus mr-1'></i>",
      unsupportedfiletypetext: 'Unsupported File Type',
      unsupportedfilesizetext: 'Unsupported File Size',
      maxsize: 29360128,
      imagecssclass: '',
      croppedfilename: 'image',
      aspectratio: '385:513',
      dragdroptitle: 'Drag &amp; drop files here …',
      forbidden: "application/x-msdownload,*.bat,*.cmd,*.scr,*.bash",
    },     
    _create: function () {        

      const [a,b] = this.options.aspectratio.split(':')
      this.aspectRatio = Number.parseFloat(a) / Number.parseFloat(b);

      this._createUiElements();
      this._tryLoadUrl(this.$croppedUrl.val() || this.$fallbackUrl.val());
      this._setEvents();
    },
    _createUiElements: function () {
      
      this.$el = this.element.closest('[data-image-cropper]').addClass('image-cropper-container')

      this.$mainContainer = $('<div></div>').appendTo(this.$el);
      this.$fileContainer = $('<div class="file-container file-advanced"></div>').appendTo(this.$mainContainer);
      this.$cropContainer = $('<div></div>').hide().appendTo(this.$el);
      this.$originalFile = this.element.hide();
      this.$croppedFile = this.$el.find('[data-image-cropper-input="cropped-file"]').hide();
      this.$originalUrl = this.$el.find('[data-image-cropper-input="original-url"]');
      this.$croppedUrl = this.$el.find('[data-image-cropper-input="cropped-url"]');
      this.$fallbackUrl = this.$el.find('[data-image-cropper-input="fallback-url"]');
      this.$meta = this.$el.find('[data-image-cropper-input="meta"]');
      this.$removed = this.$el.find('[data-image-cropper-input="removed"]').detach();
      
      if (!this.$originalUrl.length) throw new Error('Image cropper missing original-url input');
      if (!this.$croppedUrl.length) throw new Error('Image cropper missing cropped-url input');
      if (!this.$meta.length) throw new Error('Image cropper missing meta input');
      if (!this.$removed.length) throw new Error('Image cropper missing removed input');

      this.$dropZone = $('<div class="file-drop-zone clearfix"></div>').appendTo(this.$fileContainer);
      this.$dropZonePlaceholder = $('<div class="py-2"><div class="file-drop-zone-title mb-2">' + this.options.dragdroptitle + '</div></div>').appendTo(this.$dropZone);
      this.$fileList = $("<div class='file-list'></div>").appendTo(this.$dropZone);
      this.$fileListItem = $("<div class='file-list-item flex flex-column'></div>").appendTo(this.$fileList);
      this.$previewImage = $("<img class='" + this.options.imagecssclass + "'/>").hide().appendTo(this.$fileListItem);
      this.$previewIcon = $("<span class='" + this.options.imagecssclass + "'/>").hide().appendTo(this.$fileListItem);
      this.$errorMessage = $("<label class='text-danger file-info-caption'></label>").hide().appendTo(this.$fileListItem);

      this.$dropZoneButtonGroup = $('<div class="flex flex-wrap justify-content-center gap-1 pb-1"></div>').appendTo(this.$dropZonePlaceholder);
      this.$browseButton = $("<button class='btn file-btn-browse" + this.options.choosefileclass + "'>" + this.options.choosefileicon + this.options.choosefiletext + " </button>").appendTo(this.$dropZoneButtonGroup);

      this.$mainActions = $('<div class="flex flex-wrap justify-content-center gap-1 mt-1">').hide().appendTo(this.$mainContainer);
      this.$cropButton = $("<button class='btn'><i class='fas fa-crop mr-1'></i>Crop</button>").appendTo(this.$mainActions);
      this.$removeButton = $("<button class='btn btn-danger'><i class='fas fa-times mr-1'></i>Remove</button>").appendTo(this.$mainActions);

      this.$cropActions = $('<div class="flex flex-wrap justify-content-center gap-1 mb-1"></div>').appendTo(this.$cropContainer);
      this.$cropAcceptButton = $("<button class='btn'><i class='fas fa-check mr-1'></i>Accept</button></button>").appendTo(this.$cropActions);
      this.$cropCancelButton = $("<button class='btn btn-danger'><i class='fas fa-times mr-1'></i>Cancel</button>").appendTo(this.$cropActions);

    },
    _unsetImage: function() {
      this.$removed.val(true).appendTo(this.$fileContainer);
      this.$previewImage.hide();
      this.$previewIcon.hide();
      this.$mainActions.hide();
      this.$dropZonePlaceholder.show();
      this.$errorMessage.text('').hide();
      this.element[0].value = '';
      this.$croppedFile[0].value = '';
      this.element.trigger('change', true);
    },
    _showSelectionControls: function () {
      this.$removed.detach();
      this.$errorMessage.text('').hide();
      this.$mainActions.show();
      this.$dropZonePlaceholder.hide();
    },
    _setValue: function (urlOrInputFile) {  
      if (urlOrInputFile && urlOrInputFile.files && urlOrInputFile.files[0]) {
        this._showSelectionControls();
      } else {
        this._tryLoadUrl(urlOrInputFile);
        this.reset();
      }
    },
    reset: function () {
      this._unsetImage();
    },
    _tryLoadUrl: function (url) {
      if (!url) return;

      try {
        this.element.rules('remove', 'required');
      } catch (e) {
        console.warn(e);
      }

      this._showSelectionControls();

      var tmpImg = new Image();
      tmpImg.onload = () => {
        this._showPreview(url);
      };
      tmpImg.src = url;
    },
    
    _setEvents: function () {
      this.element[0].fdSetValue = this._setValue.bind(this);

      this.$browseButton.click(() => {
        this.element.trigger('click');
        return false;
      });

      this.$cropButton.click(() => {
        let image = this.lastUploadedImage || this.$originalUrl.val();
        let fallback = this.$fallbackUrl.val()
        if (!image && fallback) {
          image = fallback;
          this.$originalUrl.val(this.$fallbackUrl.val());
        }
        this._startCrop(image);
        return false;
      });

      this.$cropAcceptButton.click(() => {
        this._acceptCrop();
        return false;
      });

      this.$cropCancelButton.click(() => {
        this._stopCrop();
        return false;
      });
      
      this.$removeButton.click((e) => {
        // Note that element[0].files will still existing in this callback.
        if (this.options.callback.call(this, { parentID: this.options.parentid, value: this.element[0].files[0], isRemove: true }, e) !== false) {
          this._unsetImage();
        }
        return false;
      });
      
      this.element.off('change.fdcontrol')
          .on('change.fdcontrol', null, this, this._handleChange.bind(this));

      this.$fileContainer.on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
      }).on('dragover dragenter', () => {
          if (!this.isUploading) this.$fileContainer.addClass('is-dragover');                  
        })
        .on('dragleave dragend drop', () => {
          if (!this.isUploading) this.$fileContainer.removeClass('is-dragover');
        })
        .on('drop', (e) => {
          if (!this.isUploading) {
            this.element[0].files = e.originalEvent.dataTransfer.files;
            this._handleChange();
          } 
        });          
    },
    _startCrop: function(uri) {
      if (this.$cropImg) this.$cropImg.remove();
      this.$cropImg = $('<img/>').on('load', (e) => {
        this.$mainContainer.hide();
        this.$cropContainer.show();
      
        this.cropper = new Cropper(e.target, {
          data: safeJsonParse(this.$meta.val()), // attempt to restore last known crop position
          viewMode: 1,
          aspectRatio: this.aspectRatio,
          guides: true,
          center: false,
          highlight: false,
          rotatable: false,
          scalable: false,
          zoomable: false,
          zoomOnWheel: false,
          zoomOnTouch: false,
          cropBoxMovable: true,
          cropBoxResizable: true,
          toggleDragModeOnDblclick: false,
        });
        
      }).attr('src', uri).appendTo(this.$cropContainer);

    },
    _acceptCrop: function() {
      if (this.cropper) {
        this.$meta.val(JSON.stringify(this.cropper.getData()));

        const { aspectRatio, naturalWidth: width } = this.cropper.getImageData();        
        const height = width / aspectRatio;

        this.cropper.getCroppedCanvas({
          width,
          height,
          minWidth: width,
          minHeight: height,
          fillColor: '#fff',
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'high',
        }).toBlob((blob) => {
          this._readData(blob,(uri) => this._showPreview(uri));
          const xfr = new DataTransfer();
          xfr.items.add(new File([blob], `${this.options.croppedfilename}.jpg`,{type:"image/jpeg", lastModified:new Date().getTime()}))
          this.$croppedFile[0].files = xfr.files
        }, 'image/jpeg', 0.9)
      }
      this._stopCrop();
    },
    _stopCrop: function() {
      if (this.cropper) this.cropper.destroy();
      this.$mainContainer.show();
      this.$cropContainer.hide();
    },
    _setOption: function (key, value) {
        this.options[key] = value;
    },
    _clearInputFile: function (element) {
        element.value = '';
        this.element.valid();
    },
    _showPreview: function (url) {
      this.$previewImage.attr('src', url).show();
    },
    _handleChange: function (event, skipRemove = false) {
      var input = this.element[0];
      var self = this;
      var stopProccessing = false;

      if (!input.files || !input.files[0]) {
        if (!skipRemove) this._unsetImage();                 
        return;
      }

      $.each(input.files, function (idx) {
        if (stopProccessing) return;
        
        var fileElement = this;
        var rejectFilter = self.options.forbidden;
        var invalidFileType = (!rejectFilter || rejectFilter.replace(/\s/g, '').split(',').filter(function (accept) {
          return new RegExp(accept.replace('*', '.*')).test(fileElement.type) || new RegExp(accept.replace('*', '.*')).test(fileElement.name);
        }).length > 0);
        var acceptFilter = self.element.attr('accept');
        var validFileType = (!acceptFilter || acceptFilter.replace(/\s/g, '').split(',').filter(function (accept) {
          return new RegExp(accept.replace('*', '.*')).test(fileElement.type);
        }).length > 0);
        var validFileSize = self.options.maxsize < 0 || fileElement.size <= self.options.maxsize

        if (validFileType && validFileSize && !invalidFileType) {
          if (fileElement.type.includes('image')) {
            self._readData(fileElement, (result) => {
              if (!stopProccessing) {
                self.$meta.val('');
                self.lastUploadedImage = result;
                self._showPreview(self.lastUploadedImage)
                self._startCrop(result)
              }
            })
          } else {
            self.$previewImage.hide();
          }

          self._showSelectionControls();
        } else {
          self._unsetImage();
          
          stopProccessing = true;
          self.$errorMessage.show();
          if (!validFileType || invalidFileType) {
            if (self.options.unsupportedfiletypetext) {
              var indexOfExtension = fileElement.name.lastIndexOf('.');
              self.$errorMessage.text(self.options.unsupportedfiletypetext + (indexOfExtension > -1 ? ' (' + fileElement.name.substring(indexOfExtension) + ')' : ''));
            }
          } else if (!validFileSize) {
            if (self.options.unsupportedfilesizetext) {
              self.$errorMessage.text(self.options.unsupportedfilesizetext + ' (' + self._formatBytes(fileElement.size) + ' > ' + self._formatBytes(self.options.maxsize) + ')');
            }
          }
        }
        
        self.options.callback.call(self, { parentID: self.options.parentid, value: fileElement, validFileType: validFileType, validFileSize: validFileSize }, event);
        self.element.valid();
        
        if (validFileType && validFileSize && !invalidFileType) {
          self.element.closest('form').dirtyForms('rescan');
        }
      });
    },
    _readData(fileOrBlob, handler) {
      const reader = new FileReader();
      reader.readAsDataURL(fileOrBlob); 
      reader.onloadend = function() {
        handler(reader.result);
      }
    },
    _handleSubmit: function (event) {
      this.options.callback.call(this, { parentID: this.options.parentid, value: this.element[0].files[0] }, event);
      this.reset();
      return false;
    },
    _formatBytes: function (bytes, decimals) {
      if (decimals === undefined) {
          decimals = 2;
      }
      if (bytes === 0) {
          return '0 B';
      }

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
  });
}(jQuery));